module.exports = __webpack_public_path__ + "2839067078824feae0ec74260b98e917.png";